var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBar'),_c('v-main',[_c('router-view')],1),_c('v-footer',{staticClass:"overline",attrs:{"app":""}},[_vm._v(" v"+_vm._s(_vm.version)+" "),_c('v-spacer'),_vm._v(" Bloqs4Good 2021 ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }